import React, { useEffect, useState } from "react";
import { listCompetitionOutcomes } from "../../lib/leaderboardApi";
import ScoreActionLog from "./ScoreActionLog";
import "./ParticipantOutcomeAudit.css";

export function buildOutcomeAuditFile(matchId, events) {
  return JSON.stringify({ schemaVersion: 1, matchId, exportedAt: new Date().toISOString(), events }, null, 2);
}

export default function ParticipantOutcomeAudit({ matchId }) {
  const [open, setOpen] = useState(false);
  const [revision, setRevision] = useState(0);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!open) return undefined;
    let current = true;
    setLoading(true); setError(""); setEvents([]);
    listCompetitionOutcomes(matchId, { status: "all", includeAudit: true, auth: true }).then(rows => {
      if (current) setEvents([...new Map(rows.filter(row => row.auditEvent?.id)
        .map(row => [row.auditEvent.id, row.auditEvent])).values()]);
    }).catch(failure => { if (current) setError(failure.message || "Outcome history could not load."); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [matchId, open, revision]);

  function download() {
    const url = URL.createObjectURL(new Blob([buildOutcomeAuditFile(matchId, events)], { type: "application/json" }));
    const anchor = document.createElement("a");
    anchor.href = url; anchor.download = `${matchId}-participant-outcome-audit.json`;
    anchor.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  return <section className="participant-outcome-audit">
    <div className="participant-outcome-audit-toolbar">
      <button type="button" className="registration-auth-secondary" aria-expanded={open}
        aria-controls="participant-outcome-audit-content" onClick={() => setOpen(value => !value)}>
        {open ? "Hide Outcome History" : "Participant Outcome History"}
      </button>
      {open && <div className="participant-outcome-audit-tools">
        <button type="button" className="registration-auth-secondary" disabled={loading} onClick={() => setRevision(value => value + 1)}>Refresh</button>
        <button type="button" className="registration-auth-secondary" disabled={loading || !!error || !events.length} onClick={download}>Download Audit JSON</button>
      </div>}
    </div>
    {open && <div id="participant-outcome-audit-content">
      {loading ? <p role="status">Loading participant history...</p> : error ? <p role="alert">{error}</p> :
        <ScoreActionLog events={events} title="Participant Outcome History" />}
    </div>}
  </section>;
}
